import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Alerta from "./Alerta";
import FormModal from "./FormModal";
import { connect, useDispatch } from "react-redux";
import { atulizaSenhaUsuario, reiniciaUpCloud, salvaEmailConfiguracao } from "../redux/actions";
import { MD5 } from 'crypto-js';
import ModalConfimacao from "./ModalConfimacao";

function ConfigModal(props) {

    const [senhaAtual, setSenhaAtual] = useState(null)
    const [novaSenha, setNovaSenha] = useState(null)
    const [confimacaoSenha, setConfimacaoSenha] = useState(null)
    const [errorMessage, setErrorMessage] = useState('');
    const [showModalConfirmacao, setShowModalConfirmacao] = useState(false);
    const dispatch = useDispatch()

    const [dadosUsuarios, setDadosUsuarios] = useState(props.dadosUsuario)

    const textoConfimacao = 'essa função vai reiniciar o UpCloud dentro de um minuto se ele estiver aberto, deseja confirmar essa ação?'

    function salvaConfigs() {
        if (!senhaAtual || senhaAtual === '') {
            dispatch(salvaEmailConfiguracao(dadosUsuarios, dadosUsuarios.id))
            dispatch({type: "EXIBE_ALERTA", payload: {show: true, mensagem: "Atualizado com Sucesso", status: 'sucesso'}})
            props.abreFecha()
            return
        }
        
        if ((MD5(senhaAtual).toString().toUpperCase() !== dadosUsuarios.senha && senhaAtual !== dadosUsuarios.senha)) {
            setErrorMessage('A senha está incorreta');
            return false; // senha atual não pode estar errada
        }

        // Verificar se a senha atual corresponde à senha do usuário antes de permitir a alteração

        if (novaSenha !== confimacaoSenha) {
            setErrorMessage('As senhas devem ser iguais');
            return false; // senhas diferentes
        }

        if (!novaSenha || novaSenha.length < 8) {
            setErrorMessage('As senhas devem ter pelo menos 8 caracteres');
            return false; // senha não atende aos requisitos mínimos de segurança
        }

        setErrorMessage('')
        dispatch({type: "EXIBE_ALERTA", payload: {show: true, mensagem: "Atualizado com Sucesso", status: 'sucesso'}})
        limpaSenha()

        props.abreFecha()
        dispatch(atulizaSenhaUsuario(dadosUsuarios, novaSenha))
        limpaSenha()
        return true; // senhas iguais e com mais de 8 caracteres, atendendo aos requisitos de segurança
    }

    function limpaSenha() {
        setSenhaAtual(null)
        setNovaSenha(null)
        setConfimacaoSenha(null)
        setErrorMessage('')
    }

    const backgroudClass = (
        props.tema === 'escuro' ?
            'bg-dark border-neutral-700 text-white' :
            'bg-neutral-300 border-neutral-400'
    )

    function salvaGeral(chave, valor) {
        setDadosUsuarios(prev => ({
            ...prev,
            [chave]: valor
        }))
    }

    useEffect(() => {
        setDadosUsuarios(props.dadosUsuario)
    }, [props.show, props.dadosUsuario])

    return (
        <div>
            <ModalConfimacao show={showModalConfirmacao} titulo={'Reiniciar o UpCloud'} setShow={setShowModalConfirmacao} textoModal={textoConfimacao} funcao={() => { reiniciaUpCloud(props.dadosUsuario.id); dispatch({type: "EXIBE_ALERTA", payload: {show: true, mensagem: "Atualizado com Sucesso", status: 'sucesso'}}); setShowModalConfirmacao(false) }} />

            <Modal show={props.show} onHide={() => { props.abreFecha(); limpaSenha() }} className="modal-lg ">
                <Modal.Header closeButton className={`modal-header ${backgroudClass} `}>
                    <Modal.Title>Configurações</Modal.Title>
                </Modal.Header>


                <Modal.Body className={backgroudClass}>

                    <FormModal label='Senha Atual' type="password" placeholder='' value={senhaAtual} onChange={e => { setSenhaAtual(e.target.value); setErrorMessage('') }} className='mb-2' />
                    <FormModal label='Nova Senha' type="password" placeholder='' value={novaSenha} onChange={e => { setNovaSenha(e.target.value); setErrorMessage('') }} className='mb-2' />
                    <FormModal label='Confirme a senha' type="password" placeholder='' value={confimacaoSenha} onChange={e => { setConfimacaoSenha(e.target.value); setErrorMessage('') }} />
                    <p className="text-red-400">{errorMessage}</p>

                    <hr className="mt-4 mb-3 m-auto" />

                    <FormModal label='Email Empresa Responsável' onChange={e => salvaGeral('email_responsavel', e.target.value)} placeholder='' className='' value={dadosUsuarios.email_responsavel} />
                    <FormModal label='Email ' placeholder='' onChange={e => salvaGeral('email', e.target.value)} className='mt-2' value={dadosUsuarios.email} />
                    <p className={`${props.tema === 'escuro' ? 'text-slate-400' : 'text-slate-600'} mt-3 text-center`}>OBS: mais de um email separe por , ou ;</p>
                </Modal.Body>
                <Modal.Footer className={`${backgroudClass} footer-config-modal`}>
                    <Button variant="primary" className={`reinicia-btn ${props.tema === 'claro' && 'text-black hover:bg-blue-400'}`} onClick={() => { setShowModalConfirmacao(true) }}>
                        Reiniciar o UpCloud
                    </Button>
                    <div>
                        <Button variant="primary" className={`mr-2 ${props.tema === 'claro' && 'text-black hover:bg-blue-400'}`} onClick={() => { props.abreFecha(); limpaSenha() }}>
                            Fechar
                        </Button>
                        <Button variant="success" className={`${props.tema === 'claro' && 'text-black hover:bg-green-400 border-bg-green-400 hover:border-bg-green-400'}`} onClick={salvaConfigs}>
                            Salvar
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        tema: state.appReducer.tema,
        dadosUsuario: state.appReducer.dadosUsuario,

    }
}

export default connect(mapStateToProps, null)(ConfigModal)
